var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporatePulse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/Data/ProblembyLocation/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "corp-pulse-path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "corp-pulse-path-3",
    points: "9.19775391 0 13.1352539 0 13.1352539 4.05 11.6279297 2.49960937 7.47509766 6.73945312 4.86035156 4.05 0.922851562 8.1 0 7.15078125 4.86035156 2.1515625 7.47509766 4.84101562 10.7050781 1.55039062"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "corp-pulse-path-5",
    points: "9.19775391 0 13.1352539 0 13.1352539 4.05 11.6279297 2.49960937 7.47509766 6.73945312 4.86035156 4.05 0.922851562 8.1 0 7.15078125 4.86035156 2.1515625 7.47509766 4.84101562 10.7050781 1.55039062"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "corp-pulse-path-7",
    points: "9.19775391 0 13.1352539 0 13.1352539 4.05 11.6279297 2.49960937 7.47509766 6.73945312 4.86035156 4.05 0.922851562 8.1 0 7.15078125 4.86035156 2.1515625 7.47509766 4.84101562 10.7050781 1.55039062"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/ProblembyLocation/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "corp-pulse-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#corp-pulse-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#corp-pulse-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    mask: "url(#corp-pulse-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 1.8189894e-12,
    y: 0,
    width: 230,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 1.8189894e-12,
    y: 42,
    width: 230,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 1.8189894e-12,
    y: 85,
    width: 230,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 1.8189894e-12,
    y: 14,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 64,
    y: 14,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 129,
    y: 14,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 64,
    y: 57,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 129,
    y: 57,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 64,
    y: 100,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 129,
    y: 100,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2E5799",
    x: 178,
    y: 14,
    width: 33,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2E5799",
    x: 178,
    y: 57,
    width: 33,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2E5799",
    x: 178,
    y: 100,
    width: 33,
    height: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(216.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow/Green"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "corp-pulse-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#corp-pulse-path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#corp-pulse-mask-4)",
    fill: "#2E5799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tint/YellowGreen/3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Tint/Green/4",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(216.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow/Green"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "corp-pulse-mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#corp-pulse-path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#corp-pulse-mask-6)",
    fill: "#2E5799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tint/YellowGreen/3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Tint/Green/4",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(216.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow/Green"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "corp-pulse-mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#corp-pulse-path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#corp-pulse-mask-8)",
    fill: "#2E5799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tint/YellowGreen/3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Tint/Green/4",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 1.8189894e-12,
    y: 57,
    width: 33,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 0,
    y: 100,
    width: 32,
    height: 13
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporatePulse);
export default __webpack_public_path__ + "static/media/corporate-pulse.df698834f257f1c800e3f0b5eef64006.svg";
export { ForwardRef as ReactComponent };